"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _i18next = _interopRequireDefault(require("i18next"));

var _reactI18next = require("react-i18next");

var _reactLoudspeaker = _interopRequireDefault(require("./locales/en-US/react-loudspeaker.json"));

var _reactLoudspeaker2 = _interopRequireDefault(require("./locales/de-DE/react-loudspeaker.json"));

var _reactLoudspeaker3 = _interopRequireDefault(require("./locales/fr-FR/react-loudspeaker.json"));

var _reactLoudspeaker4 = _interopRequireDefault(require("./locales/nl-NL/react-loudspeaker.json"));

var _reactLoudspeaker5 = _interopRequireDefault(require("./locales/it-IT/react-loudspeaker.json"));

var _reactLoudspeaker6 = _interopRequireDefault(require("./locales/ja-JP/react-loudspeaker.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const res = {
  en: {
    translations: _reactLoudspeaker.default
  },
  de: {
    translations: _reactLoudspeaker2.default
  },
  fr: {
    translations: _reactLoudspeaker3.default
  },
  nl: {
    translations: _reactLoudspeaker4.default
  },
  it: {
    translations: _reactLoudspeaker5.default
  },
  ja: {
    translations: _reactLoudspeaker6.default
  }
};

const newInstance = _i18next.default.createInstance();

newInstance.use(_reactI18next.initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  defaultNS: 'translations',
  resources: res,
  react: {
    defaultTransParent: 'div'
  }
});
var _default = newInstance;
exports.default = _default;